import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export enum URLParams {
  accountId = 'accountId',
  section = 'section',
  sider = 'sidebar',
  filters = 'filters',
  siteId = 'siteId',
  controlTab = 'controlTab',
}

export const useQuery = () => {
  const { search } = useLocation() ?? { search: '' };
  const [searchParams, setSearchParams] = useState<URLSearchParams>(new URLSearchParams(search));

  useEffect(() => {
    setSearchParams(new URLSearchParams(search));
  }, [search]);

  return searchParams;
};
